import React, { Component } from "react";
import { connect } from "react-redux";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import { AccessTime, DragIndicator, Search } from "@material-ui/icons";
import ModalAdicionarCartao from "../../components/ModalAdicionarCartao";
import ModalAlterarPagamento from "../../components/ModalAlterarPagamento";
import ModalSucesso from "../../components/ModalSucesso";
import ModalPassageirosViagem from "../../components/ModalPassageirosViagem";
import Alert from "../../components/Alert";
import Swal from "sweetalert2";
import InputCustom from "../../components/InputCustom";
import InputEndereco from "../../components/InputEndereco";
import Button from "../../components/Button";
import CheckboxCustom from "../../components/CheckboxCustom";
import { getTarifas } from "../../crud/onboarding.crud";
import { getCartoes } from "../../crud/configuracao.crud";
import * as equipe_crud from "../../crud/equipe.crud";
import * as viagem_crud from "../../crud/viagem.crud";
import {
  validarViagem,
  criarPayloadViagem,
  validarRelacaoPassageiros,
  criarPassageiroVazio,
  ehVan,
  MAPA_TIPO_VEICULO,
  OPCOES_QUANTIDADE_PASSAGEIROS,
} from "./ViagemUtils";
import { validarCartao, detectarBandeira, obterTipoIconeBandeira } from "../../utils/cartaoUtils";
import styles from "../../styles/Viagem.module.scss";
import BetterSelect from "../../components/BetterSelect";
import Breadcrumb from "../../components/Breadcrumb";

const VALORES_INICIAIS_CARTAO = {
  nome_titular: "",
  cnpj_titular: "",
  numero_cartao: "",
  validade: "",
  cvv: "",
  pagamento_principal: false,
};

class ViagemNew extends Component {
  state = {
    form: {
      data_agendamento: "",
      horario_partida: "",
      local_partida: "",
      latitude: null,
      longitude: null,
      tipo_veiculo: "",
      duracao: "",
      cartao_id: "",
      passageiro_id: "",
      quantidade_passageiros: "",
      excede_municipio: false,
      destino_endereco: "",
      destino_latitude: null,
      destino_longitude: null,
    },
    erros_form: {},
    paradas: [{ local: "", horario: "" }],
    passageiros_van: [],
    modal_passageiros: false,
    modal_alterar_pagamento: false,
    modal_adicionar_cartao: false,
    modal_sucesso: false,
    loading: false,
    aviso_antecedencia: "",
    form_cartao: { ...VALORES_INICIAIS_CARTAO },
    erros_cartao: {},
    cartoes: [],
    cartao_selecionado: null,
    tipos_veiculo: [],
    loading_tarifas: false,
    cidade_sem_cobertura: false,
    colaboradores: [],
  };

  componentDidMount() {
    this.buscarColaboradores();
    this.buscarCartoes();
  }

  buscarColaboradores = () => {
    equipe_crud.simpleList()
      .then((response) => {
        this.setState({ colaboradores: response.data || [] });
      })
      .catch(() => {});
  };

  buscarCartoes = () => {
    getCartoes()
      .then((response) => {
        const cartoes = response.data;
        const principal = cartoes.find((cartao) => cartao.pagamento_principal);

        this.setState({
          cartoes,
          cartao_selecionado: principal || null,
          form: {
            ...this.state.form,
            cartao_id: principal?.id || "",
          },
        });
      })
      .catch(() => {});
  };

  carregarTarifas = (cidade) => {
    this.setState({ loading_tarifas: true, tipos_veiculo: [], cidade_sem_cobertura: false });

    getTarifas(cidade)
      .then((response) => {
        const tipos = response.data.map((tarifa) => ({
          id: MAPA_TIPO_VEICULO[tarifa.tipo_veiculo] || tarifa.tipo_veiculo,
          nome: tarifa.nome,
          antecedencia: tarifa.antecedencia,
          descricao: tarifa.descricao,
          duracoes: tarifa.duracoes.map((duracao) => ({
            valor: duracao.id,
            label: duracao.label,
            preco: duracao.preco,
            valor_minuto: duracao.valor_minuto,
            valor_km: duracao.valor_km,
          })),
        }));

        const primeiro_tipo = tipos[0];
        const sem_cobertura = tipos.length === 0;

        this.setState({
          tipos_veiculo: tipos,
          loading_tarifas: false,
          cidade_sem_cobertura: sem_cobertura,
          form: {
            ...this.state.form,
            tipo_veiculo: primeiro_tipo?.id || "",
            duracao: primeiro_tipo?.duracoes[0]?.valor || "",
          },
        });
      })
      .catch(() => {
        this.setState({ loading_tarifas: false, tipos_veiculo: [], cidade_sem_cobertura: true });
      });
  };

  handleSelecionarEndereco = (dados) => {
    this.setState((prev) => ({
      form: {
        ...prev.form,
        local_partida: dados.endereco,
        latitude: dados.latitude,
        longitude: dados.longitude,
      },
    }));

    if (dados.cidade) {
      this.carregarTarifas(dados.cidade);
    }
  };

  handleSelecionarDestino = (dados) => {
    this.setState((prev) => ({
      form: {
        ...prev.form,
        destino_endereco: dados.endereco,
        destino_latitude: dados.latitude,
        destino_longitude: dados.longitude,
      },
    }));
  };

  obterTipoSelecionado = () => {
    return this.state.tipos_veiculo.find((tipo) => tipo.id === this.state.form.tipo_veiculo);
  };

  obterDuracaoSelecionada = () => {
    const tipo = this.obterTipoSelecionado();
    return tipo?.duracoes.find((duracao) => duracao.valor === this.state.form.duracao);
  };

  handleChangeForm = (campo, valor) => {
    this.setState((prev) => {
      const update = {
        form: { ...prev.form, [campo]: valor },
        erros_form: { ...prev.erros_form, [campo]: undefined },
      };

      if (campo === "data_agendamento" || campo === "horario_partida") {
        update.aviso_antecedencia = "";
      }

      return update;
    });
  };

  handleSelecionarTipo = (tipo_id) => {
    const tipo = this.state.tipos_veiculo.find((item) => item.id === tipo_id);

    this.setState((prev) => {
      const novo_form = {
        ...prev.form,
        tipo_veiculo: tipo_id,
        duracao: tipo.duracoes[0].valor,
      };

      if (!ehVan(tipo_id)) {
        novo_form.quantidade_passageiros = "";
        novo_form.excede_municipio = false;
        novo_form.destino_endereco = "";
        novo_form.destino_latitude = null;
        novo_form.destino_longitude = null;
      }

      return { form: novo_form, passageiros_van: ehVan(tipo_id) ? prev.passageiros_van : [] };
    });
  };

  handleChangeQuantidadePassageiros = (valor) => {
    const quantidade = parseInt(valor, 10) || 0;
    const passageiros_van = Array.from({ length: quantidade }, () => criarPassageiroVazio());

    this.setState((prev) => ({
      form: { ...prev.form, quantidade_passageiros: valor },
      passageiros_van,
    }));
  };

  handleToggleExcedeMunicipio = () => {
    this.setState((prev) => {
      const novo_excede = !prev.form.excede_municipio;
      let { passageiros_van } = prev;

      if (novo_excede && prev.form.quantidade_passageiros) {
        const quantidade = parseInt(prev.form.quantidade_passageiros, 10) || 0;
        passageiros_van = Array.from({ length: quantidade }, () => criarPassageiroVazio());
      }

      if (!novo_excede) passageiros_van = [];

      return {
        form: { ...prev.form, excede_municipio: novo_excede },
        passageiros_van,
      };
    });
  };

  handleChangePassageiroVan = (index, campo, valor) => {
    this.setState((prev) => {
      const novos_passageiros = [...prev.passageiros_van];
      novos_passageiros[index] = { ...novos_passageiros[index], [campo]: valor };
      return { passageiros_van: novos_passageiros };
    });
  };

  handleAdicionarParada = () => {
    this.setState((prev) => ({
      paradas: [...prev.paradas, { local: "", horario: "" }],
    }));
  };

  handleRemoverParada = (index) => {
    this.setState((prev) => ({
      paradas: prev.paradas.filter((_, idx) => idx !== index),
    }));
  };

  handleChangeParada = (index, campo, valor) => {
    this.setState((prev) => {
      const novas_paradas = [...prev.paradas];
      novas_paradas[index] = { ...novas_paradas[index], [campo]: valor };
      return { paradas: novas_paradas };
    });
  };

  handleSelecionarCartao = (cartao) => {
    this.setState((prev) => ({
      cartao_selecionado: cartao,
      form: { ...prev.form, cartao_id: cartao.id },
      modal_alterar_pagamento: false,
    }));
  };

  handleSolicitarViagem = () => {
    const tipo_enum = ehVan(this.state.form.tipo_veiculo) ? "van" : null;
    const erros = validarViagem(this.state.form, tipo_enum);

    if (Object.keys(erros).length > 0) {
      this.setState({ erros_form: erros });
      Swal.fire("Ops!", Object.values(erros)[0], "warning");
      return;
    }

    if (ehVan(this.state.form.tipo_veiculo) && this.state.form.excede_municipio) {
      const erro_passageiros = validarRelacaoPassageiros(this.state.passageiros_van);
      if (erro_passageiros) {
        Swal.fire("Ops!", erro_passageiros, "warning");
        return;
      }
    }

    this.setState({ loading: true });

    const payload = criarPayloadViagem(this.state.form, this.state.paradas, this.state.passageiros_van);

    viagem_crud.store(payload)
      .then(() => {
        this.setState({ loading: false, modal_sucesso: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.errors?.[0] || "Erro ao solicitar viagem. Tente novamente.";

        if (msg.includes("antecedência")) {
          this.setState({ aviso_antecedencia: msg, loading: false });
          Swal.fire("Não foi possível criar a viagem", msg, "warning");
          return;
        }

        Swal.fire("Ops!", msg, "error");
        this.setState({ loading: false });
      });
  };

  handleFecharSucesso = () => {
    this.props.history.push("/viagens");
  };

  handleChangeCartao = (campo, valor) => {
    this.setState((prev) => ({
      form_cartao: { ...prev.form_cartao, [campo]: valor },
      erros_cartao: { ...prev.erros_cartao, [campo]: undefined },
    }));
  };

  handleSalvarNovoCartao = () => {
    const erros = validarCartao(this.state.form_cartao);

    if (Object.keys(erros).length > 0) {
      this.setState({ erros_cartao: erros });
      Swal.fire("Ops!", Object.values(erros)[0], "warning");
      return;
    }

    const { form_cartao } = this.state;
    const numero_limpo = form_cartao.numero_cartao.replace(/\D/g, "");
    const [mes, ano_curto] = form_cartao.validade.split("/");

    const novo_cartao = {
      ultimos_digitos: numero_limpo.slice(-4),
      bandeira: detectarBandeira(numero_limpo),
      nome_titular: form_cartao.nome_titular,
      mes_validade: parseInt(mes, 10),
      ano_validade: parseInt("20" + ano_curto, 10),
      pagamento_principal: form_cartao.pagamento_principal,
    };

    this.setState((prev) => ({
      cartoes: [...prev.cartoes, novo_cartao],
      cartao_selecionado: novo_cartao,
      form: { ...prev.form, cartao_id: novo_cartao.id || "novo" },
      modal_adicionar_cartao: false,
      form_cartao: { ...VALORES_INICIAIS_CARTAO },
    }));
  };

  renderPassageiroSelect() {
    const { form, colaboradores } = this.state;

    return (
      <div>
        <BetterSelect
          name="vei_tipo"
          label="Passageiro"
          required
          labelWidth={50}
          value={form.passageiro_id}
          onChange={(evento) => this.handleChangeForm("passageiro_id", evento.target.value)}
        >
          <option value="">Selecione</option>
          {colaboradores.map((colab) => (
            <option key={colab.id} value={colab.id}>{colab.usr_nome}</option>
          ))}
        </BetterSelect>
      </div>
    );
  }

  renderCamposVan() {
    const { form, passageiros_van } = this.state;

    if (!ehVan(form.tipo_veiculo)) return null;

    const tem_passageiros_preenchidos = passageiros_van.some(
      (passageiro) => passageiro.nome_completo || passageiro.documento
    );

    return (
      <div className={styles.campoMargem}>
        <div className={styles.gridDuasColunas}>
          <div>
            <BetterSelect
              label="Quantidade de passageiros"
              required
              value={form.quantidade_passageiros}
              onChange={(evento) => this.handleChangeQuantidadePassageiros(evento.target.value)}
              forcePlaceholder="Selecione"
            >
              {OPCOES_QUANTIDADE_PASSAGEIROS.map((opcao) => (
                <option key={opcao.valor} value={opcao.valor}>{opcao.label}</option>
              ))}
            </BetterSelect>
          </div>
        </div>

        <div className={styles.campoMargem}>
          <CheckboxCustom
            label="Viagem intermunicipal (excede o município)"
            checked={form.excede_municipio}
            onChange={this.handleToggleExcedeMunicipio}
          />
        </div>

        {form.excede_municipio && (
          <div className={styles.campoMargem}>
            <InputEndereco
              label="Local de destino"
              name="destino_endereco"
              value={form.destino_endereco}
              onChange={(evento) => this.handleChangeForm("destino_endereco", evento.target.value)}
              onSelect={this.handleSelecionarDestino}
              required
            />
          </div>
        )}

        {form.excede_municipio && form.quantidade_passageiros && (
          <div className={styles.campoMargem}>
            <Button
              type="button"
              variant="default"
              outlined
              size="sm"
              onClick={() => this.setState({ modal_passageiros: true })}
            >
              {tem_passageiros_preenchidos ? "Editar relação de passageiros" : "Adicionar relação de passageiros"}
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      form,
      erros_form,
      paradas,
      loading,
      cartao_selecionado,
      cartoes,
      tipos_veiculo,
      loading_tarifas,
      cidade_sem_cobertura,
      aviso_antecedencia,
      modal_passageiros,
      modal_alterar_pagamento,
      modal_adicionar_cartao,
      modal_sucesso,
      passageiros_van,
      form_cartao,
      erros_cartao,
    } = this.state;

    const duracao_ativa = this.obterDuracaoSelecionada();

    const touched_form = {
      data_agendamento: true,
      horario_partida: true,
      local_partida: true,
      tipo_veiculo: true,
      duracao: true,
      cartao_id: true,
      passageiro_id: true,
      quantidade_passageiros: true,
      destino_endereco: true,
    };

    const touched_cartao = Object.keys(VALORES_INICIAIS_CARTAO).reduce(
      (acc, chave) => ({ ...acc, [chave]: true }), {}
    );

    return (
      <div className={styles.container}>
        <Breadcrumb paiTo="/viagens" paiLabel="Viagens" atual="Solicitar viagem" />

        <div className={styles.card}>
          <p className={styles.secaoTitulo}>Dados gerais</p>

          <div className={styles.gridDuasColunas}>
            <InputCustom
              label="Solicitante"
              name="solicitante"
              type="text"
              value={this.props.user?.usr_nome || ""}
              readOnly
            />

            {this.renderPassageiroSelect()}
          </div>

          <div className={`${styles.gridDuasColunas} ${styles.campoMargem}`}>
            <InputCustom
              label="Data da viagem"
              name="data_agendamento"
              type="date"
              value={form.data_agendamento}
              onChange={(evento) => this.handleChangeForm("data_agendamento", evento.target.value)}
              disabled={loading}
              required
              errors={erros_form}
              touched={touched_form}
            />

            <InputCustom
              label="Horário de partida"
              name="horario_partida"
              type="time"
              value={form.horario_partida}
              onChange={(evento) => this.handleChangeForm("horario_partida", evento.target.value)}
              disabled={loading}
              required
              errors={erros_form}
              touched={touched_form}
            />
          </div>

          <div className={styles.campoMargem}>
            <InputEndereco
              label="Local de partida"
              name="local_partida"
              value={form.local_partida}
              onChange={(evento) => this.handleChangeForm("local_partida", evento.target.value)}
              onSelect={this.handleSelecionarEndereco}
              disabled={loading}
              required
              errors={erros_form}
              touched={touched_form}
            />

            {aviso_antecedencia && (
              <div className={styles.campoMargem}>
                <Alert variant="warning">{aviso_antecedencia}</Alert>
              </div>
            )}
          </div>

          <hr className={styles.separadorSecao} />

          <p className={styles.secaoTitulo}>Tipo de veículo e duração da viagem</p>
          <p className={styles.secaoDescricao}>Selecione o tipo de veículo e duração que melhor atende às necessidades da sua viagem.</p>

          {loading_tarifas && <p>Carregando tipos de veículo...</p>}

          {!loading_tarifas && !cidade_sem_cobertura && tipos_veiculo.length === 0 && (
            <p className={styles.secaoDescricao}>Selecione o local de partida para visualizar os veículos disponíveis.</p>
          )}

          {cidade_sem_cobertura && (
            <div className={styles.emptySemCobertura}>
              <Search style={{ fontSize: 48, color: "var(--gray-5)" }} />
              <p className={styles.emptyDescricao}>Parece que ainda não atendemos a cidade de partida informada. Se possível, selecione outra localidade para continuar.</p>
            </div>
          )}

          {tipos_veiculo.map((tipo) => {
            const selecionado = tipo.id === form.tipo_veiculo;

            return (
              <div
                key={tipo.id}
                className={selecionado ? styles.tipoVeiculoCardSelecionado : styles.tipoVeiculoCard}
                onClick={() => this.handleSelecionarTipo(tipo.id)}
              >
                <div className={styles.tipoVeiculoHeader}>
                  <input
                    type="radio"
                    className={styles.radioInput}
                    checked={selecionado}
                    onChange={() => {}}
                  />
                  <span className={styles.tipoVeiculoNome}>{tipo.nome}</span>
                  <span className={`${styles.tipoVeiculoAntecedencia} ${styles.italico}`}>Antecedência mínima: {tipo.antecedencia}</span>
                </div>

                <p className={styles.tipoVeiculoDescricao}>{tipo.descricao}</p>

                {selecionado && (
                  <>
                    <div className={`${styles.gridDuasColunas} ${styles.campoMargem}`}>
                      <div>
                        <BetterSelect
                          label="Duração da viagem"
                          required
                          value={form.duracao}
                          onChange={(evento) => this.handleChangeForm("duracao", evento.target.value)}
                        >
                          {tipo.duracoes.map((duracao) => (
                            <option key={duracao.valor} value={duracao.valor}>{duracao.label}</option>
                          ))}
                        </BetterSelect>

                        {duracao_ativa && (
                          <p className={styles.helperExtra}>
                            Min extra: {duracao_ativa.valor_minuto != null ? `R$ ${duracao_ativa.valor_minuto.toFixed(2).replace(".", ",")}` : "—"}
                            &nbsp;&nbsp;
                            Km extra: {duracao_ativa.valor_km != null ? `R$ ${duracao_ativa.valor_km.toFixed(2).replace(".", ",")}` : "—"}
                          </p>
                        )}
                      </div>

                      <InputCustom
                        label="Valor"
                        name="valor"
                        type="text"
                        value={duracao_ativa?.preco || ""}
                        readOnly
                      />
                    </div>

                    <div className={styles.campoMargem}>
                      <Alert variant="warning">
                        O valor exibido corresponde à cobrança de uma tarifa base, com base no tipo de veículo escolhido. Caso a quilometragem ou o tempo de locação ultrapassem os limites contratados, será aplicado um valor adicional por quilômetro ou minuto excedente.
                      </Alert>
                    </div>

                    {this.renderCamposVan()}
                  </>
                )}
              </div>
            );
          })}

          <hr className={styles.separadorSecao} />

          <p className={styles.secaoTitulo}>Agenda de compromissos</p>
          <p className={styles.secaoDescricao}>
            Adicione os locais de parada que deverão ser realizados durante a viagem. Isso ajudará o motorista a planejar o melhor percurso, de acordo com suas necessidades.
          </p>

          {paradas.map((parada, index) => (
            <div key={index} className={styles.paradaLinha}>
              <DragIndicator className={styles.dragHandle} />

              <InputEndereco
                label="Local"
                name={`local_${index}`}
                value={parada.local}
                onChange={(evento) => this.handleChangeParada(index, "local", evento.target.value)}
                onSelect={(dados) => this.handleChangeParada(index, "local", dados.endereco)}
              />

              <InputCustom
                label="Horário"
                name={`horario_${index}`}
                type="time"
                value={parada.horario}
                onChange={(evento) => this.handleChangeParada(index, "horario", evento.target.value)}
                icon_left={<AccessTime />}
              />

              <button
                className={styles.botaoRemover}
                onClick={() => this.handleRemoverParada(index)}
              >
                ×
              </button>
            </div>
          ))}

          <Button
            type="button"
            variant="default"
            outlined
            size="sm"
            onClick={this.handleAdicionarParada}
          >
            Adicionar parada +
          </Button>

          <hr className={styles.separadorSecao} />

          <p className={styles.secaoTitulo}>Forma de pagamento</p>

          <div className={styles.pagamentoRow}>
            <div className={styles.pagamentoInfo}>
              {cartao_selecionado ? (
                <PaymentIcon type={obterTipoIconeBandeira(cartao_selecionado.bandeira)} format="logo" width={40} />
              ) : (
                <PaymentIcon type="generic" format="logo" width={40} />
              )}

              <div>
                <p className={styles.pagamentoTexto}>
                  {cartao_selecionado
                    ? `Cartão de crédito ****${cartao_selecionado.ultimos_digitos}`
                    : "Nenhum cartão cadastrado"}
                </p>
                <p className={styles.pagamentoValidade}>
                  {cartao_selecionado
                    ? `${String(cartao_selecionado.mes_validade).padStart(2, "0")}/${cartao_selecionado.ano_validade}`
                    : "Adicione um cartão para continuar"}
                </p>
              </div>
            </div>

            <button
              className={styles.linkAlterar}
              onClick={() => this.setState({ modal_alterar_pagamento: true })}
            >
              Alterar
            </button>
          </div>
        </div>

        <div className={styles.botoesRodape}>
          <Button
            type="button"
            variant="default"
            outlined
            size="md"
            disabled={loading}
            onClick={() => this.props.history.push("/viagens")}
          >
            Cancelar
          </Button>

          <Button
            type="button"
            variant="primary"
            size="md"
            loading={loading}
            disabled={loading}
            onClick={this.handleSolicitarViagem}
          >
            Solicitar viagem
          </Button>
        </div>

        <ModalAlterarPagamento
          aberto={modal_alterar_pagamento}
          onFechar={() => this.setState({ modal_alterar_pagamento: false })}
          cartoes={cartoes}
          cartao_selecionado={cartao_selecionado}
          onSelecionarCartao={this.handleSelecionarCartao}
          onAdicionarCartao={() => this.setState({ modal_alterar_pagamento: false, modal_adicionar_cartao: true })}
        />

        <ModalAdicionarCartao
          aberto={modal_adicionar_cartao}
          onFechar={() => this.setState({ modal_adicionar_cartao: false })}
          form_cartao={form_cartao}
          erros_cartao={erros_cartao}
          touched={touched_cartao}
          onChangeCartao={this.handleChangeCartao}
          onSalvar={this.handleSalvarNovoCartao}
        />

        <ModalPassageirosViagem
          aberto={modal_passageiros}
          passageiros={passageiros_van}
          onFechar={() => this.setState({ modal_passageiros: false })}
          onChange={this.handleChangePassageiroVan}
        />

        <ModalSucesso
          aberto={modal_sucesso}
          onFechar={this.handleFecharSucesso}
          titulo="Viagem solicitada!"
          descricao="Você será notificado quando sua viagem for aceita por um de nossos motoristas."
          texto_botao="Fechar"
        />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(ViagemNew);
